export class ApiSettings {
   public static API_URL='https://app.masconberto.com/';
}

export class CounterSettings {
   public static TICKET_COUNTER_LABEL = 'ticket_counter';
   public static INVOICE_COUNTER_LABEL = 'invoice_counter';
   public static TECHNICALSERVICE_INVOICE_COUNTER_LABEL = 'technicalservice_invoice_counter';
   public static RETURN_TICKET_COUNTER_LABEL = 'return_ticket_counter';
   public static RETURN_INVOICE_COUNTER_LABEL = 'return_invoice_counter';
   public static RETURN_TECHNICALSERVICE_INVOICE_COUNTER_LABEL = 'return_technicalservice_invoice_counter';
}


// WEBPACK FOOTER //
// ./src/app/api.settings.ts